import { Injectable, Type } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from, of } from 'rxjs';
import { filter, map, mergeMap, switchMap, tap, toArray } from 'rxjs/operators';
//import { DynamicComponentFour, DynamicComponentOne, DynamicComponentSix, DynamicComponentThree, DynamicComponentTwentyTwo, DynamicComponentTwo, FieldTypes } from 'src/app/project-display/feature/equipment-and-capacities-container/equipment-and-capacities-container.component';
import { IOptionalComponent } from 'src/app/project-display/interfaces/IProjectHeader';

// Equipment Section
import { AssetCarbonCapture, PowerCapacity } from 'src/app/project-display/ui/equipment/equipment.components';
import { PowerFuelTypes } from 'src/app/project-display/ui/equipment/equipment.components';
import { WindTurbines } from 'src/app/project-display/ui/equipment/equipment.components';
import { FieldTypes } from 'src/app/project-display/ui/equipment/equipment.components';
import { LNGPlants } from 'src/app/project-display/ui/equipment/equipment.components';
import { Pipelines } from 'src/app/project-display/ui/equipment/equipment.components';
import { Storage } from 'src/app/project-display/ui/equipment/equipment.components';
import { Terminals } from 'src/app/project-display/ui/equipment/equipment.components';
import { ElectricalCables } from 'src/app/project-display/ui/equipment/equipment.components';
import { Platforms } from 'src/app/project-display/ui/equipment/equipment.components';
import { FloatingUnits } from 'src/app/project-display/ui/equipment/equipment.components';
import { CCSTechnologyAndStorage } from 'src/app/project-display/ui/equipment/equipment.components';
import { EmissionSystems } from 'src/app/project-display/ui/equipment/equipment.components';
// import { Flowlines } from 'src/app/project-display/ui/equipment/equipment.components';
// import { Risers } from 'src/app/project-display/ui/equipment/equipment.components';
// import { SubseaTrees } from 'src/app/project-display/ui/equipment/equipment.components';
// import { Umbilicals } from 'src/app/project-display/ui/equipment/equipment.components';
import { TidalTurbines } from 'src/app/project-display/ui/equipment/equipment.components';
import { Wells } from 'src/app/project-display/ui/equipment/equipment.components';
import { Compressors } from 'src/app/project-display/ui/equipment/equipment.components';
import { ProcessFacilities } from 'src/app/project-display/ui/equipment/equipment.components';
import { Manifolds } from 'src/app/project-display/ui/equipment/equipment.components';
import { GasProcessing } from 'src/app/project-display/ui/equipment/equipment.components';
import { Solar } from 'src/app/project-display/ui/equipment/equipment.components';
import { WaveDevices } from 'src/app/project-display/ui/equipment/equipment.components';
import { Geothermal } from 'src/app/project-display/ui/equipment/equipment.components';
import { DrillingFacilities } from 'src/app/project-display/ui/equipment/equipment.components';
import { Vessels } from 'src/app/project-display/ui/equipment/equipment.components';
import { AluminiumFacility } from 'src/app/project-display/ui/equipment/equipment.components';
import { Plant } from 'src/app/project-display/ui/equipment/equipment.components';
import { Surf } from 'src/app/project-display/ui/equipment/equipment.components';
import { CapexPackages } from 'src/app/project-display/ui/equipment/equipment.components';
import { HydrogenCapacity } from 'src/app/project-display/ui/equipment/equipment.components';
import { ProjectDataService } from 'src/app/project-display/data-access/project-data.service';

// interface IOptionalComponent {
//     optionalComponentID: number;
// }

interface IComponentData {
    type: Type<any>;
    //id: number;
    data$: Observable<any>;
}



@Injectable({
    providedIn: 'root',
})
export class DynamicComponentService {

    constructor(private projectDataService:ProjectDataService) { }

    // This metho takes the list of Optional Components
    // to be loaded and turns it into a list of actual
    // component types complete with the data that is to 
    // be passed into the instance
    // getting the data involves asynchronously dipatching 
    // http calls to  specific endpoints (which don't yet 
    // exist). The projectId is needed for this (as well
    // as a bit of switchMap() magic, I think).
    // Additionally, the data for each component will now 
    // be presented as an observable  (ie Observable<any>)  
    // getComponentList(projectId: number, optionalComponents: Observable<IOptionalComponent[]>): Observable<{ type: Type<any>, id: number, data$: Observable<any> }[]> {
       

    //     return optionalComponents.pipe(
    //         mergeMap(o => from(o)),
    //         map((o: IOptionalComponent) => {
    //             switch (o.optionalComponentID) {
    //                 case 1:
    //                     const powerCapacityData$ = this.getPowerCapacityData(projectId);
    //                     return {
    //                         type: PowerCapacity,
    //                         id: o.optionalComponentID,
    //                         data$: powerCapacityData$
    //                     };
    //                 case 2:
    //                     const powerFuelTypesData$ = this.getPowerFuelTypesData(projectId);
    //                     return {
    //                         type: PowerFuelTypes,
    //                         id: o.optionalComponentID,
    //                         data$: powerFuelTypesData$
    //                     };
    //                 case 3:
    //                     const windTurbinesData$ = this.getWindTurbinesData(projectId);
    //                     return {
    //                         type: WindTurbines,
    //                         id: o.optionalComponentID,
    //                         data$: windTurbinesData$
    //                     };
    //                 case 4:
    //                     const fieldTypesData$ = this.getFieldTypesData(projectId);
    //                     return {
    //                         type: FieldTypes,
    //                         id: o.optionalComponentID,
    //                         data$: fieldTypesData$
    //                     };
    //                 case 5:
    //                     const lngPlantsData$ = this.getLNGPlantsData(projectId);
    //                     return {
    //                         type: LNGPlants,
    //                         id: o.optionalComponentID,
    //                         data$: lngPlantsData$
    //                     };
    //                 case 6:
    //                     const pipelinesData$ = this.getPipelinesData(projectId);
    //                     return {
    //                         type: Pipelines,
    //                         id: o.optionalComponentID,
    //                         data$: pipelinesData$
    //                     };
    //                 case 7:
    //                     const storageData$ = this.getStorageData(projectId);
    //                     return {
    //                         type: Storage,
    //                         id: o.optionalComponentID,
    //                         data$: storageData$
    //                     };
    //                 case 8:
    //                     const terminalsData$ = this.getTerminalsData(projectId);
    //                     return {
    //                         type: Terminals,
    //                         id: o.optionalComponentID,
    //                         data$: terminalsData$
    //                     };
    //                 case 9:
    //                 case 10:
    //                 case 11:
    //                     const electricalCablesData$ = this.getElectricalCablesData(projectId);
    //                     return {
    //                         type: ElectricalCables,
    //                         id: o.optionalComponentID,
    //                         data$: electricalCablesData$
    //                     };
    //                 case 12:
    //                     const platformsData$ = this.getPlatformsData(projectId);
    //                     return {
    //                         type: Platforms,
    //                         id: o.optionalComponentID,
    //                         data$: platformsData$
    //                     };
    //                 case 13:
    //                     const floatingUnitsData$ = this.getFloatingUnitsData(projectId);
    //                     return {
    //                         type: FloatingUnits,
    //                         id: o.optionalComponentID,
    //                         data$: floatingUnitsData$
    //                     };
    //                 case 14:
    //                     return {
    //                         type: null,
    //                         id: o.optionalComponentID,
    //                         data$: null
    //                     };
    //                 case 15:
    //                     const ccsTechnologyAndStorageData$ = this.getCCSTechnologyAndStorageData(projectId);
    //                     return {
    //                         type: CCSTechnologyAndStorage,
    //                         id: o.optionalComponentID,
    //                         data$: ccsTechnologyAndStorageData$
    //                     };
    //                 case 16:
    //                     const emissionSystemsData$ = this.getEmissionSystemsData(projectId);
    //                     return {
    //                         type: EmissionSystems,
    //                         id: o.optionalComponentID,
    //                         data$: emissionSystemsData$
    //                     };
    //                 case 17:
    //                     const flowlinesData$ = this.getFlowlinesData(projectId);
    //                     return {
    //                         type: Flowlines,
    //                         id: o.optionalComponentID,
    //                         data$: flowlinesData$
    //                     };
    //                 case 18:
    //                     const risersData$ = this.getRisersData(projectId);
    //                     return {
    //                         type: Risers,
    //                         id: o.optionalComponentID,
    //                         data$: risersData$
    //                     };
    //                 case 19:
    //                     const subseaTreesData$ = this.getSubseaTreesData(projectId);
    //                     return {
    //                         type: SubseaTrees,
    //                         id: o.optionalComponentID,
    //                         data$: subseaTreesData$
    //                     };
    //                 case 20:
    //                     const umbilicalsData$ = this.getUmbilicalsData(projectId);
    //                     return {
    //                         type: Umbilicals,
    //                         id: o.optionalComponentID,
    //                         data$: umbilicalsData$
    //                     };
    //                 case 21:
    //                     const tidalTurbinesData$ = this.getTidalTurbinesData(projectId);
    //                     return {
    //                         type: TidalTurbines,
    //                         id: o.optionalComponentID,
    //                         data$: tidalTurbinesData$
    //                     };
    //                 case 22:
    //                     const wellsData$ = this.getWellsData(projectId);
    //                     return {
    //                         type: Wells,
    //                         id: o.optionalComponentID,
    //                         data$: wellsData$
    //                     };
    //                 case 23:
    //                     const compressorsData$ = this.getCompressorsData(projectId);
    //                     return {
    //                         type: Compressors,
    //                         id: o.optionalComponentID,
    //                         data$: compressorsData$
    //                     };
    //                 case 24:
    //                     const processFacilitiesData$ = this.getProcessFacilitiesData(projectId);
    //                     return {
    //                         type: ProcessFacilities,
    //                         id: o.optionalComponentID,
    //                         data$: processFacilitiesData$
    //                     };
    //                 case 25:
    //                     const manifoldsData$ = this.getManifoldsData(projectId);
    //                     return {
    //                         type: Manifolds,
    //                         id: o.optionalComponentID,
    //                         data$: manifoldsData$
    //                     };
    //                 case 26:
    //                     const gasProcessingData$ = this.getGasProcessingData(projectId);
    //                     return {
    //                         type: GasProcessing,
    //                         id: o.optionalComponentID,
    //                         data$: gasProcessingData$
    //                     };
    //                 case 27:
    //                     const solarData$ = this.getSolarData(projectId);
    //                     return {
    //                         type: Solar,
    //                         id: o.optionalComponentID,
    //                         data$: solarData$
    //                     };
    //                 case 28:
    //                     const waveDevicesData$ = this.getWaveDevicesData(projectId);
    //                     return {
    //                         type: WaveDevices,
    //                         id: o.optionalComponentID,
    //                         data$: waveDevicesData$
    //                     };
    //                 case 29:
    //                     const geothermalData$ = this.getGeothermalData(projectId);
    //                     return {
    //                         type: Geothermal,
    //                         id: o.optionalComponentID,
    //                         data$: geothermalData$
    //                     };
    //                 case 30:
    //                     const drillingFacilitiesData$ = this.getDrillingFacilitiesData(projectId);
    //                     return {
    //                         type: DrillingFacilities,
    //                         id: o.optionalComponentID,
    //                         data$: drillingFacilitiesData$
    //                     };
    //                 case 31:
    //                     const vesselsData$ = this.getVesselsData(projectId);
    //                     return {
    //                         type: Vessels,
    //                         id: o.optionalComponentID,
    //                         data$: vesselsData$
    //                     };
    //                 case 32:
    //                     const aluminiumFacilityData$ = this.getAluminiumFacilityData(projectId);
    //                     return {
    //                         type: AluminiumFacility,
    //                         id: o.optionalComponentID,
    //                         data$: aluminiumFacilityData$
    //                     };
    //                 case 33:
    //                     const plantData$ = this.getPlantData(projectId);
    //                     return {
    //                         type: Plant,
    //                         id: o.optionalComponentID,
    //                         data$: plantData$
    //                     };
    //                 case 34:
    //                     const surfData$ = this.getSurfData(projectId);
    //                     return {
    //                         type: Surf,
    //                         id: o.optionalComponentID,
    //                         data$: surfData$
    //                     };
    //                 case 35:
    //                     const capexPackagesData$ = this.getCapexPackagesData(projectId);
    //                     return {
    //                         type: CapexPackages,
    //                         id: o.optionalComponentID,
    //                         data$: capexPackagesData$
    //                     };
    //                 case 36:
    //                     const hydrogenCapacityData$ = this.getHydrogenCapacityData(projectId);
    //                     return {
    //                         type: HydrogenCapacity,
    //                         id: o.optionalComponentID,
    //                         data$: hydrogenCapacityData$
    //                     };
    //                 default:
    //                     return {
    //                         type: null,
    //                         id: o.optionalComponentID,
    //                         data$: null
    //                     };
    //             }






    //             // switch (o.optionalComponentID) {
    //             //     //     "PowerCapacity.html",             // 1
    //             //     //     "PowerFuelTypes.html",            // 2
    //             //     //     "WindTurbines.html",              // 3
    //             //     //     "FieldTypes.html",                // 4
    //             //     //     "LNGPlants.html",                 // 5
    //             //     //     "Pipelines.html",                 // 6
    //             //     //     "Storage.html",                   // 7
    //             //     //     "Terminals.html",                 // 8
    //             //     //     "ElectricalCables.html",          // 9
    //             //     //     "ElectricalCables.html",          // 10
    //             //     //     "ElectricalCables.html",          // 11
    //             //     //     "Platforms.html",                 // 12
    //             //     //     "FloatingUnits.html",             // 13
    //             //     //     "",                               // 14
    //             //     //     "CCSTechnologyAndStorage.html",   // 15
    //             //     //     "EmissionSystems.html",           // 16
    //             //     //     "Flowlines.html",                 // 17
    //             //     //     "Risers.html",                    // 18
    //             //     //     "SubseaTrees.html",               // 19
    //             //     //     "Umbilicals.html",                // 20
    //             //     //     "TidalTurbines.html",             // 21
    //             //     //     "Wells.html",                     // 22
    //             //     //     "Compressors.html",               // 23
    //             //     //     "ProcessFacilities.html",         // 24
    //             //     //     "Manifolds.html",                 // 25
    //             //     //     "Gas Processing.html",            // 26
    //             //     //     "Solar.html",                     // 27
    //             //     //     "WaveDevices.html",               // 28
    //             //     //     "Geothermal.html",                // 29
    //             //     //     "DrillingFacilities.html",        // 30
    //             //     //     "Vessels.html",                   // 31
    //             //     //     "Aluminium Facility.html",        // 32
    //             //     //     "Plant.html",                     // 33
    //             //     //     "Surf.html",                      // 34
    //             //     //     "CapexPackages.html",             // 35
    //             //     //     "HydrogenCapacity.html",          // 36
    //             //     case 1:
    //             //         const powerCapacityData$ = this.getPowerCapacityData(projectId);
    //             //         return {
    //             //             type: PowerCapacity,
    //             //             id: o.optionalComponentID,
    //             //             data$: powerCapacityData$
    //             //         };
               
    //             //     case 2:
    //             //         return {
    //             //             type: DynamicComponentTwo,
    //             //             id: o.optionalComponentID,
    //             //             data$: this.getGreetingData('Two!')
    //             //         };

    //             //     case 3:
    //             //         return {
    //             //             type: DynamicComponentThree,
    //             //             id: o.optionalComponentID,
    //             //             data$: this.getGreetingData('Three!')
    //             //         };
            
            
    //             //     case 4:
    //             //         const fieldData$ = this.getFieldData(projectId);
    
    //             //         return {
    //             //             type: FieldTypes,
    //             //             id: o.optionalComponentID,
    //             //             data$: fieldData$
    //             //         };

    //             //     case 41:
    //             //         return {
    //             //             type: DynamicComponentFour,
    //             //             id: o.optionalComponentID,
    //             //             data$: this.getGreetingData('Four!')
    //             //         };

    //             //     case 6:
    //             //         return {
    //             //             type: DynamicComponentSix,
    //             //             id: o.optionalComponentID,
    //             //             data$: this.getGreetingData('Six!')
    //             //         };

    //             //     case 22:
    //             //         return {
    //             //             type: DynamicComponentTwentyTwo,
    //             //             id: o.optionalComponentID,
    //             //             data$: this.getGreetingData('Twenty Two!')
    //             //         };

    //             // }
    //              return null;

    //         }),
    //         filter(item => item !== null),
    //         toArray() // Collect all emitted items into an array
    //     )
    // }

    // getComponentList2(projectId: number, optionalComponents: Observable<IOptionalComponent[]>): Observable<{ type: Type<any>, id: number, data$: Observable<any> }[]> {
    //     this.http.get(`/projects/${projectId}/equipment`).pipe(
    //         mergeMap((response: Observable<any>) => {
    //             const {
    //                 powerCapacity, powerFuelTypes, windTurbines, fieldTypes, lngPlants, pipelines, storage, terminals, electricalCables, platforms, floatingUnits, ccsTechnologyAndStorage, emissionSystems, flowlines, risers, subseaTrees, umbilicals, tidalTurbines, wells, compressors, processFacilities, manifolds, gasProcessing, solar, waveDevices, geothermal, drillingFacilities, vessels, aluminiumFacility, plant, surf, capexPackages, hydrogenCapacity } = response;

    //             return optionalComponents.pipe(
    //                 mergeMap(o => from(o)),
    //                 map((o: IOptionalComponent) => {
    //                     switch (o.optionalComponentID) {
    //                         case 1:
    //                             return {
    //                                 type: PowerCapacity,
    //                                 id: o.optionalComponentID,
    //                                 data$: powerCapacity
    //                             };
    //                         case 2:
    //                             return {
    //                                 type: PowerFuelTypes,
    //                                 id: o.optionalComponentID,
    //                                 data$: powerFuelTypes
    //                             };
    //                         case 3:
    //                             return {
    //                                 type: WindTurbines,
    //                                 id: o.optionalComponentID,
    //                                 data$: windTurbines
    //                             };
    //                         case 4:
    //                             return {
    //                                 type: FieldTypes,
    //                                 id: o.optionalComponentID,
    //                                 data$: fieldTypes
    //                             };
    //                         case 5:
    //                             return {
    //                                 type: LNGPlants,
    //                                 id: o.optionalComponentID,
    //                                 data$: lngPlants
    //                             };
    //                         case 6:
    //                             return {
    //                                 type: Pipelines,
    //                                 id: o.optionalComponentID,
    //                                 data$: pipelines
    //                             };
    //                         case 7:
    //                             return {
    //                                 type: Storage,
    //                                 id: o.optionalComponentID,
    //                                 data$: storage
    //                             };
    //                         case 8:
    //                             return {
    //                                 type: Terminals,
    //                                 id: o.optionalComponentID,
    //                                 data$: terminals
    //                             };
    //                         case 9:
    //                         case 10:
    //                         case 11:
    //                             return {
    //                                 type: ElectricalCables,
    //                                 id: o.optionalComponentID,
    //                                 data$: electricalCables
    //                             };
    //                         case 12:
    //                             return {
    //                                 type: Platforms,
    //                                 id: o.optionalComponentID,
    //                                 data$: platforms
    //                             };
    //                         case 13:
    //                             return {
    //                                 type: FloatingUnits,
    //                                 id: o.optionalComponentID,
    //                                 data$: floatingUnits
    //                             };
    //                         case 14:
    //                             return {
    //                                 type: null,
    //                                 id: o.optionalComponentID,
    //                                 data$: null
    //                             };
    //                         case 15:
    //                             return {
    //                                 type: CCSTechnologyAndStorage,
    //                                 id: o.optionalComponentID,
    //                                 data$: ccsTechnologyAndStorage
    //                             };
    //                         case 16:
    //                             return {
    //                                 type: EmissionSystems,
    //                                 id: o.optionalComponentID,
    //                                 data$: emissionSystems
    //                             };
    //                         case 17:
    //                             return {
    //                                 type: Flowlines,
    //                                 id: o.optionalComponentID,
    //                                 data$: flowlines
    //                             };
    //                         case 18:
    //                             return {
    //                                 type: Risers,
    //                                 id: o.optionalComponentID,
    //                                 data$: risers
    //                             };
    //                         case 19:
    //                             return {
    //                                 type: SubseaTrees,
    //                                 id: o.optionalComponentID,
    //                                 data$: subseaTrees
    //                             };
    //                         case 20:
    //                             return {
    //                                 type: Umbilicals,
    //                                 id: o.optionalComponentID,
    //                                 data$: umbilicals
    //                             };
    //                         case 21:
    //                             return {
    //                                 type: TidalTurbines,
    //                                 id: o.optionalComponentID,
    //                                 data$: tidalTurbines
    //                             };
    //                         case 22:
    //                             return {
    //                                 type: Wells,
    //                                 id: o.optionalComponentID,
    //                                 data$: wells
    //                             };
    //                         case 23:
    //                             return {
    //                                 type: Compressors,
    //                                 id: o.optionalComponentID,
    //                                 data$: compressors
    //                             };
    //                         case 24:
    //                             return {
    //                                 type: ProcessFacilities,
    //                                 id: o.optionalComponentID,
    //                                 data$: processFacilities
    //                             };
    //                         case 25:
    //                             return {
    //                                 type: Manifolds,
    //                                 id: o.optionalComponentID,
    //                                 data$: manifolds
    //                             };
    //                         case 26:
    //                             return {
    //                                 type: GasProcessing,
    //                                 id: o.optionalComponentID,
    //                                 data$: gasProcessing
    //                             };
    //                         case 27:
    //                             return {
    //                                 type: Solar,
    //                                 id: o.optionalComponentID,
    //                                 data$: solar
    //                             };
    //                         case 28:
    //                             return {
    //                                 type: WaveDevices,
    //                                 id: o.optionalComponentID,
    //                                 data$: waveDevices
    //                             };
    //                         case 29:
    //                             return {
    //                                 type: Geothermal,
    //                                 id: o.optionalComponentID,
    //                                 data$: geothermal
    //                             };
    //                         case 30:
    //                             return {
    //                                 type: DrillingFacilities,
    //                                 id: o.optionalComponentID,
    //                                 data$: drillingFacilities
    //                             };
    //                         case 31:
    //                             return {
    //                                 type: Vessels,
    //                                 id: o.optionalComponentID,
    //                                 data$: vessels
    //                             };
    //                         case 32:
    //                             return {
    //                                 type: AluminiumFacility,
    //                                 id: o.optionalComponentID,
    //                                 data$: aluminiumFacility
    //                             };
    //                         case 33:
    //                             return {
    //                                 type: Plant,
    //                                 id: o.optionalComponentID,
    //                                 data$: plant
    //                             };
    //                         case 34:
    //                             return {
    //                                 type: Surf,
    //                                 id: o.optionalComponentID,
    //                                 data$: surf
    //                             };
    //                         case 35:
    //                             return {
    //                                 type: CapexPackages,
    //                                 id: o.optionalComponentID,
    //                                 data$: capexPackages
    //                             };
    //                         case 36:
    //                             return {
    //                                 type: HydrogenCapacity,
    //                                 id: o.optionalComponentID,
    //                                 data$: hydrogenCapacity
    //                             };
                            
    //                         default:
    //                             return {
    //                                 type: null,
    //                                 id: o.optionalComponentID,
    //                                 data$: null
    //                             };
    //                     }
    //                 }),
    //                 filter(item => item !== null),
    //                 toArray() // Collect all emitted items into an array
    //             );
    //         })
    //     );
    // }

    // getComponentList3(projectId: number, optionalComponents: Observable<IOptionalComponent[]>): Observable<IComponentData[]> {
    //     return this.getEquipment(projectId) 
    //         .pipe(
    //             mergeMap(response => {
    //                 const {
    //                     powerCapacity,
    //                     powerFuelTypes,
    //                     windTurbines,
    //                     fieldTypes,
    //                     lngPlants,
    //                     pipelines,
    //                     // storage,
    //                     // terminals,
    //                     // electricalCables,
    //                     platforms,
    //                     floatingUnits,
    //                     // ccsTechnologyAndStorage,
    //                     // emissionSystems,
    //                     // flowlines,
    //                     // risers,
    //                     // subseaTrees,
    //                     // umbilicals,
    //                     // tidalTurbines,
    //                     wells,
    //                    // compressors,
    //                     processFacilities,
    //                     // manifolds,
    //                     // gasProcessing,
    //                     // solar,
    //                     // waveDevices,
    //                     // geothermal,
    //                     // drillingFacilities,
    //                     // vessels,
    //                     // aluminiumFacility,
    //                     // plant,
    //                     // surf,
    //                     // capexPackages,
    //                     // hydrogenCapacity           
    //                 } = response;

    //                 return optionalComponents.pipe(
    //                     mergeMap(o => from(o)),
    //                     map((o: IOptionalComponent) => {
    //                         switch (o.optionalComponentID) {
    //                             case 1:
    //                                 return { type: PowerCapacity, id: o.optionalComponentID, data$: powerCapacity };
    //                             case 2:
    //                                 return { type: PowerFuelTypes, id: o.optionalComponentID, data$: powerFuelTypes };
    //                             case 3:
    //                                 return { type: WindTurbines, id: o.optionalComponentID, data$: windTurbines };
    //                             case 4:
    //                                 return { type: FieldTypes, id: o.optionalComponentID, data$: fieldTypes };
    //                             case 5:
    //                                 return { type: LNGPlants, id: o.optionalComponentID, data$: lngPlants };
    //                             case 6:
    //                                 return { type: Pipelines, id: o.optionalComponentID, data$: pipelines };
    //                             // case 7:
    //                             //     return { type: Storage, id: o.optionalComponentID, data$: storage };
    //                             // case 8:
    //                             //     return { type: Terminals, id: o.optionalComponentID, data$: terminals };
    //                             // case 9:
    //                             // case 10:
    //                             // case 11:
    //                             //     return { type: ElectricalCables, id: o.optionalComponentID, data$: electricalCables };
    //                             case 12:
    //                                 return { type: Platforms, id: o.optionalComponentID, data$: platforms };
    //                             case 13:
    //                                 return { type: FloatingUnits, id: o.optionalComponentID, data$: floatingUnits };
    //                             case 14:
    //                                 return { type: null, id: o.optionalComponentID, data$: null };
    //                             // case 15:
    //                             //     return { type: CCSTechnologyAndStorage, id: o.optionalComponentID, data$: ccsTechnologyAndStorage };
    //                             // case 16:
    //                             //     return { type: EmissionSystems, id: o.optionalComponentID, data$: emissionSystems };
    //                             // case 17:
    //                             //     return { type: Flowlines, id: o.optionalComponentID, data$: flowlines };
    //                             // case 18:
    //                             //     return { type: Risers, id: o.optionalComponentID, data$: risers };
    //                             // case 19:
    //                             //     return { type: SubseaTrees, id: o.optionalComponentID, data$: subseaTrees };
    //                             // case 20:
    //                             //     return { type: Umbilicals, id: o.optionalComponentID, data$: umbilicals };
    //                             // case 21:
    //                             //     return { type: TidalTurbines, id: o.optionalComponentID, data$: tidalTurbines };
    //                             case 22:
    //                                 return { type: Wells, id: o.optionalComponentID, data$: wells };
    //                             // case 23:
    //                             //     return { type: Compressors, id: o.optionalComponentID, data$: compressors };
    //                             case 24:
    //                                 return { type: ProcessFacilities, id: o.optionalComponentID, data$: processFacilities };
    //                             // case 25:
    //                             //     return { type: Manifolds, id: o.optionalComponentID, data$: manifolds };
    //                             // case 26:
    //                             //     return { type: GasProcessing, id: o.optionalComponentID, data$: gasProcessing };
    //                             // case 27:
    //                             //     return { type: Solar, id: o.optionalComponentID, data$: solar };
    //                             // case 28:
    //                             //     return { type: WaveDevices, id: o.optionalComponentID, data$: waveDevices };
    //                             // case 29:
    //                             //     return { type: Geothermal, id: o.optionalComponentID, data$: geothermal };
    //                             // case 30:
    //                             //     return { type: DrillingFacilities, id: o.optionalComponentID, data$: drillingFacilities };
    //                             // case 31:
    //                             //     return { type: Vessels, id: o.optionalComponentID, data$: vessels };
    //                             // case 32:
    //                             //     return { type: AluminiumFacility, id: o.optionalComponentID, data$: aluminiumFacility };
    //                             // case 33:
    //                             //     return { type: Plant, id: o.optionalComponentID, data$: plant };
    //                             // case 34:
    //                             //     return { type: Surf, id: o.optionalComponentID, data$: surf };
    //                             // case 35:
    //                             //     return { type: CapexPackages, id: o.optionalComponentID, data$: capexPackages };
    //                             // case 36:
    //                             //     return { type: HydrogenCapacity, id: o.optionalComponentID, data$: hydrogenCapacity };
    //                             default:
    //                                 return { type: null, id: o.optionalComponentID, data$: null };
    //                         }
    //                     }),
    //                     filter(item => item.type !== null),
    //                     toArray()
    //                 );
    //             })
    //         );
    // }

    // getComponentList4(projectId: number): Observable<IComponentData[]> {
    //     return this.getEquipment(projectId).pipe(
    //         map(response => {
    //             const {
    //                 powerCapacity,
    //                 powerFuelTypes,
    //                 windTurbines,
    //                 fieldTypes,
    //                 lngPlants,
    //                 pipelines,
    //                 platforms,
    //                 floatingUnits,
    //                 wells,
    //                 processFacilities
    //             } = response;

    //             const components: IComponentData[] = [];

    //             if (powerCapacity) components.push({ type: PowerCapacity, data$: powerCapacity });
    //             if (powerFuelTypes) components.push({ type: PowerFuelTypes, data$: powerFuelTypes });
    //             if (windTurbines) components.push({ type: WindTurbines, data$: windTurbines });
    //             if (fieldTypes) components.push({ type: FieldTypes, data$: fieldTypes });
    //             if (lngPlants) components.push({ type: LNGPlants, data$: lngPlants });
    //             if (pipelines) components.push({ type: Pipelines, data$: pipelines });
    //             if (platforms) components.push({ type: Platforms, data$: platforms });
    //             if (floatingUnits) components.push({ type: FloatingUnits, data$: floatingUnits });
    //             if (wells) components.push({ type: Wells, data$: wells });
    //             if (processFacilities) components.push({ type: ProcessFacilities, data$: processFacilities });

    //             return components;
    //         })
    //     );
    // }

    // Now we are ignoring the list of Optional Components and rendering a 
    // component for any key that has data in the response

    // Shared by both Asset and Project equipment sources -- keys must match
    // the property names actually present on each respective API response
    private readonly componentMap = {
        powerCapacity: PowerCapacity,
        fuelTypes: PowerFuelTypes,
        windTurbines: WindTurbines,
        fieldTypes: FieldTypes,
        lngPlants: LNGPlants,
        pipelines: Pipelines,
        storages: Storage,
        terminals: Terminals,
        electricalCables: ElectricalCables,
        platforms: Platforms,
        floatingUnits: FloatingUnits,
        ccsTechnology: CCSTechnologyAndStorage,
        emissionSystems: EmissionSystems,
        // flowlines: Flowlines,
        // risers: Risers,
        // subseaTrees: SubseaTrees,
        // umbilicals: Umbilicals,
        tidalTurbines: TidalTurbines,
        wells: Wells,
        compressors: Compressors,
        processFacilities: ProcessFacilities,
        manifolds: Manifolds,
        gasProcessing: GasProcessing,
        solar: Solar,
        waveDevices: WaveDevices,
        geothermal: Geothermal,
        drillingFacilities: DrillingFacilities,
        vessels: Vessels,
        aluminiumFacility: AluminiumFacility,
        plants: Plant,
        surf: Surf,
        capexPackages: CapexPackages,
        hydrogenCapacity: HydrogenCapacity,
        assetCarbonCapturePlants: AssetCarbonCapture
    };

    // Empty arrays are truthy in JS -- the full /api/project/{id} payload always
    // includes every equipment field, most as [] when not applicable, so an
    // explicit emptiness check is required (unlike a plain truthy check).
    private hasEquipmentData(value: any): boolean {
        if (value === null || value === undefined) return false;
        if (Array.isArray(value)) return value.length > 0;
        return true;
    }

    private buildComponentList(response: any): IComponentData[] {
        const components: IComponentData[] = [];
        if (!response) return components;

        for (const key in this.componentMap) {
            if (this.hasEquipmentData(response[key])) {
                components.push({ type: this.componentMap[key], data$: response[key] });
            }
        }

        return components;
    }

    // Assets: equipment fields are served from the dedicated /api/projects/{id}/equipment endpoint
    getComponentList5(projectId: number): Observable<IComponentData[]> {
        return this.projectDataService.getProjectEquipment(projectId).pipe(
            map(response => this.buildComponentList(response))
        );
    }

    // Projects: equipment fields (eg. ccsTechnology) are embedded directly on the /api/project/{id} payload
    getComponentListFromProject(project: any): Observable<IComponentData[]> {
        return of(this.buildComponentList(project));
    }


    // getPowerCapacityData(projectId: number) {
    //     return of({
    //         "powerOutput": 900,
    //         "thermalOutput": 500,
    //         "powerCapacity": 1800,
    //         "batteryType": "Sodium-sulfur"
    //     });
    // }

    // getPowerFuelTypesData(projectId: number) {
    //     return of([
    //         {
    //             "powerFuelType": "Solar",
    //             "technologyTypes": ["Photovoltaic", "Concentrated Solar Power"]
    //         },
    //         {
    //             "powerFuelType": "Wind",
    //             "technologyTypes": ["Onshore Wind Turbines", "Offshore Wind Turbines"]
    //         },
    //         {
    //             "powerFuelType": "Hydro",
    //             "technologyTypes": ["Run-of-the-River", "Reservoir", "Pumped Storage"]
    //         },
    //         {
    //             "powerFuelType": "Biomass",
    //             "technologyTypes": ["Direct Combustion", "Gasification", "Anaerobic Digestion"]
    //         },
    //         {
    //             "powerFuelType": "Geothermal",
    //             "technologyTypes": ["Dry Steam", "Flash Steam", "Binary Cycle"]
    //         }
    //     ]);
    // }

    // getWindTurbinesData(projectId: number) {
    //     return of([
    //         {
    //             "windTurbineType": "Horizontal Axis",
    //             "minNumberOfTurbines": 5,
    //             "maxNumberOfTurbines": 10,
    //             "exactNumberOfTurbines": null,
    //             "height": 100,
    //             "hubHeight": 80,
    //             "bladeLength": 50,
    //             "deviceCapacity": 2.5,
    //             "offshoreWindFoundationType": "Monopile",
    //             "manufacturer": "Siemens"
    //         },
    //         {
    //             "windTurbineType": "Vertical Axis",
    //             "minNumberOfTurbines": null,
    //             "maxNumberOfTurbines": 15,
    //             "exactNumberOfTurbines": null,
    //             "height": 120,
    //             "hubHeight": 90,
    //             "bladeLength": 60,
    //             "deviceCapacity": 3.0,
    //             "offshoreWindFoundationType": "Jacket",
    //             "manufacturer": "GE"
    //         },
    //         {
    //             "windTurbineType": "Horizontal Axis",
    //             "minNumberOfTurbines": 8,
    //             "maxNumberOfTurbines": null,
    //             "exactNumberOfTurbines": null,
    //             "height": 110,
    //             "hubHeight": 85,
    //             "bladeLength": 55,
    //             "deviceCapacity": 2.8,
    //             "offshoreWindFoundationType": "Floating",
    //             "manufacturer": "Vestas"
    //         },
    //         {
    //             "windTurbineType": "Vertical Axis",
    //             "minNumberOfTurbines": null,
    //             "maxNumberOfTurbines": null,
    //             "exactNumberOfTurbines": 12,
    //             "height": 130,
    //             "hubHeight": 95,
    //             "bladeLength": 65,
    //             "deviceCapacity": 3.5,
    //             "offshoreWindFoundationType": "Gravity Base",
    //             "manufacturer": "Nordex"
    //         },
    //         {
    //             "windTurbineType": "Horizontal Axis",
    //             "minNumberOfTurbines": 10,
    //             "maxNumberOfTurbines": 20,
    //             "exactNumberOfTurbines": null,
    //             "height": 140,
    //             "hubHeight": 100,
    //             "bladeLength": 70,
    //             "deviceCapacity": 4.0,
    //             "offshoreWindFoundationType": "Monopile",
    //             "manufacturer": "Suzlon"
    //         }
    //     ]);
    // }

    // getFieldTypesData(projectId: number) {
    //     return of([
    //         {
    //             "type": "Oil",
    //             "subType": "Light Crude",
    //             "production": 100000,
    //             "productionUnit": "barrels/day",
    //             "reserves": 5000000,
    //             "reservesUnit": "barrels",
    //             "life": 15
    //         },
    //         {
    //             "type": "Gas",
    //             "subType": "Natural Gas",
    //             "production": 200000,
    //             "productionUnit": "cubic meters/day",
    //             "reserves": 10000000,
    //             "reservesUnit": "cubic meters",
    //             "life": 20
    //         },
    //         {
    //             "type": "Oil",
    //             "subType": "Heavy Crude",
    //             "production": 150000,
    //             "productionUnit": "barrels/day",
    //             "reserves": 7000000,
    //             "reservesUnit": "barrels",
    //             "life": 18
    //         },
    //         {
    //             "type": "Gas",
    //             "subType": "Shale Gas",
    //             "production": 250000,
    //             "productionUnit": "cubic meters/day",
    //             "reserves": 12000000,
    //             "reservesUnit": "cubic meters",
    //             "life": 25
    //         },
    //         {
    //             "type": "Oil",
    //             "subType": "Bitumen",
    //             "production": 80000,
    //             "productionUnit": "barrels/day",
    //             "reserves": 3000000,
    //             "reservesUnit": "barrels",
    //             "life": 10
    //         }
    //     ]);
    // }

    // getLNGPlantsData(projectId: number) {
    //     return of([
    //         {
    //             "lngPlantType": "Liquefaction Plant",
    //             "lngPlantFluids": [
    //                 {
    //                     "fluidTypeID": 12,
    //                     "material": "Methane",
    //                     "annualCapacity": 5000000,
    //                     "annualRateUnit": "tons",
    //                     "trains": 3
    //                 }
    //             ]
    //         },
    //         {
    //             "lngPlantType": "Regasification Plant",
    //             "lngPlantFluids": [
    //                 {
    //                     "fluidTypeID": 12,
    //                     "material": "Ethane",
    //                     "annualCapacity": 3000000,
    //                     "annualRateUnit": "tons",
    //                     "trains": 2
    //                 }
    //             ]
    //         },
    //         {
    //             "lngPlantType": "Liquefaction Plant",
    //             "lngPlantFluids": [
    //                 {
    //                     "fluidTypeID": 12,
    //                     "material": "Propane",
    //                     "annualCapacity": 4000000,
    //                     "annualRateUnit": "tons",
    //                     "trains": 4
    //                 }
    //             ]
    //         },
    //         {
    //             "lngPlantType": "Regasification Plant",
    //             "lngPlantFluids": [
    //                 {
    //                     "fluidTypeID": 12,
    //                     "material": "Butane",
    //                     "annualCapacity": 3500000,
    //                     "annualRateUnit": "tons",
    //                     "trains": 3
    //                 }
    //             ]
    //         },
    //         {
    //             "lngPlantType": "Liquefaction Plant",
    //             "lngPlantFluids": [
    //                 {
    //                     "fluidTypeID": 12,
    //                     "material": "Methane",
    //                     "annualCapacity": 6000000,
    //                     "annualRateUnit": "tons",
    //                     "trains": 5
    //                 }
    //             ]
    //         }
    //     ]);
    // }

    // getPipelinesData(projectId: number) {
    //     return of([{
    //         "fluidType": "Natural Gas",
    //         "isOnshore": true,
    //         "isOffshore": false,
    //         "length": 120,
    //         "diameter": 36,
    //         "dailyCapacity": 500000,
    //         "dailyRateUnit": "cubic meters",
    //         "annualCapacity": 182500000,
    //         "annualRateUnit": "cubic meters"
    //     },
    //     {
    //         "fluidType": "Crude Oil",
    //         "isOnshore": false,
    //         "isOffshore": true,
    //         "length": 200,
    //         "diameter": 42,
    //         "dailyCapacity": 750000,
    //         "dailyRateUnit": "barrels",
    //         "annualCapacity": 273750000,
    //         "annualRateUnit": "barrels"
    //     },
    //     {
    //         "fluidType": "Refined Products",
    //         "isOnshore": true,
    //         "isOffshore": true,
    //         "length": 150,
    //         "diameter": 30,
    //         "dailyCapacity": 300000,
    //         "dailyRateUnit": "liters",
    //         "annualCapacity": 109500000,
    //         "annualRateUnit": "liters"
    //     }]);
    // }

    // getStorageData(projectId: number) {
    //     return of([{ greeting: "hello from getStorageData" }]);
    // }

    // getTerminalsData(projectId: number) {
    //     return of([{ greeting: "hello from getTerminalsData" }]);
    // }

    // getElectricalCablesData(projectId: number) {
    //     return of([{ greeting: "hello from getElectricalCablesData" }]);
    // }

    // getPlatformsData(projectId: number) {
    //     return of([
    //         {
    //             "platformStructureType": "Fixed Platform",
    //             "platformTypes": ["Steel Jacket", "Concrete Gravity"],
    //             "count": 5
    //         },
    //         {
    //             "platformStructureType": "Compliant Tower",
    //             "platformTypes": ["Guyed Tower", "Seastar"],
    //             "count": 3
    //         },
    //         {
    //             "platformStructureType": "Semi-submersible",
    //             "platformTypes": ["Column Stabilized", "Tension Leg"],
    //             "count": 4
    //         },
    //         {
    //             "platformStructureType": "Spar Platform",
    //             "platformTypes": ["Classic Spar", "Truss Spar"],
    //             "count": 2
    //         },
    //         {
    //             "platformStructureType": "Floating Production System",
    //             "platformTypes": ["FPSO", "FSO"],
    //             "count": 6
    //         }
    //     ]);
    // }

    // getFloatingUnitsData(projectId: number) {
    //     return of([
    //         {
    //             "floatingUnitType": "FPSO",
    //             "vessel": "Vessel A",
    //             "vesselStatus": "Active",
    //             "leaseStart": "2022-01-01T00:00:00Z",
    //             "leaseYears": 10,
    //             "leaseOptionalYears": 5,
    //             "fluids": [
    //                 {
    //                     "material": "Oil",
    //                     "maxDailyCapacity": 100000,
    //                     "dailyRateUnit": "barrels",
    //                     "storageTotal": 2000000,
    //                     "storageUnit": "barrels"
    //                 }
    //             ]
    //         },
    //         {
    //             "floatingUnitType": "FSO",
    //             "vessel": "Vessel B",
    //             "vesselStatus": "Inactive",
    //             "leaseStart": "2020-06-01T00:00:00Z",
    //             "leaseYears": 8,
    //             "leaseOptionalYears": 3,
    //             "fluids": [
    //                 {
    //                     "material": "Gas",
    //                     "maxDailyCapacity": 50000,
    //                     "dailyRateUnit": "cubic meters",
    //                     "storageTotal": 1000000,
    //                     "storageUnit": "cubic meters"
    //                 }
    //             ]
    //         },
    //         {
    //             "floatingUnitType": "FLNG",
    //             "vessel": "Vessel C",
    //             "vesselStatus": "Active",
    //             "leaseStart": "2021-03-01T00:00:00Z",
    //             "leaseYears": 12,
    //             "leaseOptionalYears": 4,
    //             "fluids": [
    //                 {
    //                     "material": "LNG",
    //                     "maxDailyCapacity": 200000,
    //                     "dailyRateUnit": "tons",
    //                     "storageTotal": 4000000,
    //                     "storageUnit": "tons"
    //                 }
    //             ]
    //         },
    //         {
    //             "floatingUnitType": "Drillship",
    //             "vessel": "Vessel D",
    //             "vesselStatus": "Under Maintenance",
    //             "leaseStart": "2019-09-01T00:00:00Z",
    //             "leaseYears": 7,
    //             "leaseOptionalYears": 2,
    //             "fluids": [
    //                 {
    //                     "material": "Oil",
    //                     "maxDailyCapacity": 80000,
    //                     "dailyRateUnit": "barrels",
    //                     "storageTotal": 1600000,
    //                     "storageUnit": "barrels"
    //                 }
    //             ]
    //         },
    //         {
    //             "floatingUnitType": "Semi-submersible",
    //             "vessel": "Vessel E",
    //             "vesselStatus": "Active",
    //             "leaseStart": "2023-05-01T00:00:00Z",
    //             "leaseYears": 15,
    //             "leaseOptionalYears": 5,
    //             "fluids": [
    //                 {
    //                     "material": "Gas",
    //                     "maxDailyCapacity": 60000,
    //                     "dailyRateUnit": "cubic meters",
    //                     "storageTotal": 1200000,
    //                     "storageUnit": "cubic meters"
    //                 }
    //             ]
    //         }
    //     ]);
    // }

    // getCCSTechnologyAndStorageData(projectId: number) {
    //     return of([{ greeting: "hello from getCCSTechnologyAndStorageData" }]);
    // }

    // getEmissionSystemsData(projectId: number) {
    //     return of([{ greeting: "hello from getEmissionSystemsData" }]);
    // }

    // getFlowlinesData(projectId: number) {
    //     return of([{ greeting: "hello from getFlowlinesData" }]);
    // }

    // getRisersData(projectId: number) {
    //     return of([{ greeting: "hello from getRisersData" }]);
    // }

    // getSubseaTreesData(projectId: number) {
    //     return of([{ greeting: "hello from getSubseaTreesData" }]);
    // }

    // getUmbilicalsData(projectId: number) {
    //     return of([{ greeting: "hello from getUmbilicalsData" }]);
    // }

    // getTidalTurbinesData(projectId: number) {
    //     return of([{ greeting: "hello from getTidalTurbinesData" }]);
    // }

    // getWellsData(projectId: number) {
    //     return of([
    //         {
    //             "type": "Exploration",
    //             "count": 10
    //         },
    //         {
    //             "type": "Development",
    //             "count": 15
    //         },
    //         {
    //             "type": "Production",
    //             "count": 20
    //         },
    //         {
    //             "type": "Injection",
    //             "count": 5
    //         },
    //         {
    //             "type": "Abandoned",
    //             "count": 8
    //         }
    //     ]);
    // }

    // getCompressorsData(projectId: number) {
    //     return of([{ greeting: "hello from getCompressorsData" }]);
    // }

    // getProcessFacilitiesData(projectId: number) {
    //     return of([
    //         {
    //             "fluidType": "Oil",
    //             "capacity": 50000,
    //             "capacityUnit": "barrels/day",
    //             "terrain": "Onshore"
    //         },
    //         {
    //             "fluidType": "Gas",
    //             "capacity": 100000,
    //             "capacityUnit": "cubic meters/day",
    //             "terrain": "Offshore"
    //         },
    //         {
    //             "fluidType": "Water",
    //             "capacity": 20000,
    //             "capacityUnit": "cubic meters/day",
    //             "terrain": "Onshore"
    //         },
    //         {
    //             "fluidType": "LNG",
    //             "capacity": 30000,
    //             "capacityUnit": "tons/day",
    //             "terrain": "Offshore"
    //         },
    //         {
    //             "fluidType": "Condensate",
    //             "capacity": 40000,
    //             "capacityUnit": "barrels/day",
    //             "terrain": "Onshore"
    //         }
    //     ]);
    // }

    // getManifoldsData(projectId: number) {
    //     return of([{ greeting: "hello from getManifoldsData" }]);
    // }

    // getGasProcessingData(projectId: number) {
    //     return of([{ greeting: "hello from getGasProcessingData" }]);
    // }

    // getSolarData(projectId: number) {
    //     return of([{ greeting: "hello from getSolarData" }]);
    // }

    // getWaveDevicesData(projectId: number) {
    //     return of([{ greeting: "hello from getWaveDevicesData" }]);
    // }

    // getGeothermalData(projectId: number) {
    //     return of([{ greeting: "hello from getGeothermalData" }]);
    // }

    // getDrillingFacilitiesData(projectId: number) {
    //     return of([{ greeting: "hello from getDrillingFacilitiesData" }]);
    // }

    // getVesselsData(projectId: number) {
    //     return of([{ greeting: "hello from getVesselsData" }]);
    // }

    // getAluminiumFacilityData(projectId: number) {
    //     return of([{ greeting: "hello from getAluminiumFacilityData" }]);
    // }

    // getPlantData(projectId: number) {
    //     return of([{ greeting: "hello from getPlantData" }]);
    // }

    // getSurfData(projectId: number) {
    //     return of({
    //         "subseaTrees": [
    //             { "type": "Vertical", "count": 10 },
    //             { "type": "Horizontal", "count": 5 }
    //         ],
    //         "umbilicals": [
    //             { "type": "Hydraulic", "length": 15 },
    //             { "type": "Electrical", "length": 20 }
    //         ],
    //         "risers": [
    //             { "type": "Flexible", "length": 100 },
    //             { "type": "Rigid", "length": 150 }
    //         ],
    //         "flowlines": [
    //             { "type": "Production", "fluid": "Oil", "length": 30.5, "diameter": 8 },
    //             { "type": "Injection", "fluid": "Water", "length": 25.0, "diameter": 6 },
    //             { "type": "Export", "fluid": "Gas", "length": 40.0, "diameter": 10 }
    //         ]
    //     });
    // }

    // getCapexPackagesData(projectId: number) {
    //     return of([{ greeting: "hello from getCapexPackagesData" }]);
    // }

    // getHydrogenCapacityData(projectId: number) {
    //     return of([{ greeting: "hello from getHydrogenCapacityData" }]);
    // }

    // getFieldData(projectId: number) {
    //     return of([
    //         {
    //             "hydrocarbonTypeID": 1,
    //             "type": "Oil",
    //             "reservesUnit": "MMbbl",
    //             "production": 80000,
    //             "productionUnit": "b/d"
    //         },
    //         {
    //             "hydrocarbonTypeID": 1,
    //             "type": "Oil",
    //             "reserves": 50000,
    //             "reservesUnit": "MMbbl",
    //             "production": 50000,
    //             "productionUnit": "b/d"
    //         },
    //         {
    //             "hydrocarbonTypeID": 1,
    //             "type": "Oil",
    //             "reservesUnit": "MMbbl",
    //             "production": 70000,
    //             "productionUnit": "b/d"
    //         }
    //     ])

    //    // return this.http.get(`/projects/${projectId}/fields`);
    // }

    // getGreetingData(msg:string): Observable<any> {
    //     return of({ greeting: `Hello from Component ${msg}!` });
    // }

}
